import apiClient, { extractData } from '../api-client';

// API công khai (không cần đăng nhập) — xác thực bằng token trong query.
export const publicApi = {
  // Danh sách đơn ĐANG SẢN XUẤT cho bảng QR xưởng (thợ may quét xem).
  getProductionBoard(token) {
    return apiClient
      .get('/public/production-board', { params: { t: token } })
      .then(extractData);
  },

  // QR hoàn thành SX (/hoan-thanh-sx?t=…): đơn ĐANG SẢN XUẤT + thợ bấm Hoàn thành SX.
  // Bị chặn mạng vẫn 200 `allowed: false`.
  getFactoryOrders(token) {
    return apiClient.get('/public/factory/orders', { params: { t: token } }).then(extractData);
  },
  // Dùng fetch `keepalive` (không qua axios): thợ khoá máy / đóng trang ngay sau khi
  // bấm thì lệnh vẫn tới server. Lỗi ném dạng giống axios (`err.response.status/data`).
  async completeFactoryOrders(token, orderCodes, { keepalive = false } = {}) {
    const res = await fetch(`${apiClient.defaults.baseURL}/public/factory/complete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ t: token, order_codes: orderCodes }),
      keepalive,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.detail || `HTTP ${res.status}`);
      err.response = { status: res.status, data };
      throw err;
    }
    return data;
  },

  // Snapshot realtime cho màn hình TV treo ở xưởng (doanh thu/đơn/BXH/tiến độ).
  getTvDashboard(token, theme = 'dark') {
    return apiClient
      .get('/public/tv-dashboard', { params: { t: token, theme } })
      .then(extractData);
  },

  // In phiếu qua QR dán ở xưởng (/in-phieu?t=…). Lệnh theo dõi bằng `handle` ngẫu nhiên.
  getPrintStation(token) {
    return apiClient.get('/public/print-station', { params: { t: token } }).then(extractData);
  },
  // Ảnh in demo đơn Chờ SX + Đang SX để chọn đơn bằng ảnh thay vì gõ mã.
  getQrPrintGallery(token) {
    return apiClient.get('/public/print-station/gallery', { params: { t: token } }).then(extractData);
  },
  sendQrPrint(token, orderCode, name) {
    return apiClient
      .post('/public/print-station/jobs', { t: token, order_code: orderCode, name })
      .then(extractData);
  },
  getQrPrintJob(token, handle) {
    return apiClient
      .get(`/public/print-station/jobs/${encodeURIComponent(handle)}`, { params: { t: token } })
      .then(extractData);
  },
  cancelQrPrintJob(token, handle) {
    return apiClient
      .post(`/public/print-station/jobs/${encodeURIComponent(handle)}/cancel`, null, { params: { t: token } })
      .then(extractData);
  },
};
